import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    component: () => import('@/views/layout/BasicLayout.vue'),
    meta: { title: '/',requireAuth:true },
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/views/HomeView.vue'),
        meta: { requireAuth:true },
      },
      {
        path: '/appt/create',
        component: () => import('@/views/Appt/CreateView.vue'),
        meta: { requireAuth:true },
      },
      {
        path: '/appt/list',
        component: () => import('@/views/Appt/ListView.vue'),
        meta: { requireAuth:true },
      },
      {
        path: '/appt/:id',
        component: () => import('@/views/Appt/DetailView.vue'),
        meta: { requireAuth:true },
      },
      {
        path: '/account/list',
        component: () => import('@/views/Account/ListView.vue'),
        meta: { requireAuth:true },
      },
      {
        path: '/account/create',
        component: () => import('@/views/Account/CreateView.vue'),
        meta: { requireAuth:true },
      },
      {
        path: '/account/:id/edit',
        component:()=>import('@/views/Account/EditView.vue'),
        meta: { requireAuth:true },
      },
      {
        path: '/change_password',
        component:()=>import('@/views/ChangePasswordView.vue'),
        meta: { requireAuth:true },
      },
    ],
  },
  {path: '/register',component: () => import('../views/RegisterView.vue')},
  {path: '/login',component: () => import('../views/LoginView.vue')},
  {path: '/reset_password',component: () => import('../views/ResetPasswordView.vue')},
  {path: '/forget_password',component: () => import('../views/ForgetPasswordView.vue')},
]  


const router = createRouter({
  base:'',
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to,from,next)=>{
  const token = localStorage.getItem('sitc-appt-m-token');
  if(to.path == '/login' || to.path == '/register' || to.path == '/resetpwd' || to.path == '/resetpwd_verify'){
    if(token){
      next({path:'/'});
    }
    else{
      next();
    }
  }
  else{
    if(to.meta.requireAuth === true){
      if(!token){
        next({path:'/login'});
      }
      else{
        next();
      }
    }
    else{
      next();
    }
  }
});

export default router
